// src/app/guards/non-auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NonAuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = this.authService.getAuthToken();
    const isValid = token && !this.authService.isTokenExpired(token);

    return isValid ? this.router.parseUrl('/home') : true;
  }
}
